import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import CreatorBox from '@components/Template/CreatorBox';

const SellerTab: FC = () => {
  return (
    <Box flexBasis={'100%'} align="center" margin={'24px 0'}>
      <CreatorBox isMobileView={true} isSticky={false} textSize="small" />
    </Box>
  );
};

export default SellerTab;
